// Client-side mirror of the backend password policy (auth/password_policy.py).
// UX only — the server remains the source of truth and re-validates every password.

const COMMON_PASSWORDS = new Set([
  'password', 'password1', 'password123', 'passw0rd', '123456', '1234567',
  '12345678', '123456789', '1234567890', '12345', '1234', '123123', '111111',
  '000000', 'qwerty', 'qwerty123', 'qwertyuiop', 'abc123', 'admin', 'admin123',
  'administrator', 'letmein', 'welcome', 'welcome1', 'iloveyou', 'monkey',
  'dragon', 'sunshine', 'princess', 'football', 'baseball', 'master', 'login',
  'starwars', 'whatever', 'trustno1', 'changeme', 'secret', 'test', 'test123',
  'root', 'toor', 'pass', 'pass123', 'p@ssw0rd', 'p@ssword', 'aaaaaa', 'asdfgh',
  'zaq12wsx', '1q2w3e4r', 'qazwsx',
]);

export const PASSWORD_MIN_LENGTH = 8;

export function getPasswordChecks(password = '', email = '') {
  const pw = password || '';
  const local = (email || '').split('@')[0].toLowerCase().trim();
  return [
    { key: 'length', label: `At least ${PASSWORD_MIN_LENGTH} characters`, ok: pw.length >= PASSWORD_MIN_LENGTH },
    { key: 'upper', label: 'An uppercase letter', ok: /[A-Z]/.test(pw) },
    { key: 'lower', label: 'A lowercase letter', ok: /[a-z]/.test(pw) },
    { key: 'digit', label: 'A number', ok: /[0-9]/.test(pw) },
    { key: 'special', label: 'A special character', ok: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(pw) },
    { key: 'notcommon', label: 'Not a common password', ok: pw.length > 0 && !COMMON_PASSWORDS.has(pw.toLowerCase()) },
    {
      key: 'notemail',
      label: 'Does not contain your email',
      ok: !(local && local.length >= 3 && pw.toLowerCase().includes(local)),
    },
  ];
}

export function isPasswordStrong(password, email) {
  return getPasswordChecks(password, email).every((c) => c.ok);
}
